module.exports = __webpack_public_path__ + "img/marketing.cdb57100.svg";